import * as React from 'react'

import { PlayState } from '@envato/react-video'

import FullscreenExitIcon from '../../icons/fullscreenExit'
import PauseIcon from '../../icons/pauseIsolated'
import PlayIcon from '../../icons/playIsolated'

import * as styles from './videoControlsFullscreen.module.css'

interface IProps {
  playState: PlayState
  onPause: () => any
  onPlay: () => any
  onExitFullscreen: () => any
  onMouseMove: () => any
}

const { PLAY, PAUSE } = PlayState

class VideoControlsFullscreen extends React.Component<IProps> {
  public render() {
    const {
      playState,
      onPlay,
      onPause,
      onExitFullscreen,
      onMouseMove
    } = this.props

    return (
      <div role="button" className={styles.root} onMouseMove={onMouseMove}>
        {playState === PLAY && (
          <button onClick={onPause}>
            <PauseIcon className={styles.icon} />
          </button>
        )}
        {playState === PAUSE && (
          <button onClick={onPlay}>
            <PlayIcon className={styles.icon} />
          </button>
        )}

        <button onClick={onExitFullscreen}>
          <FullscreenExitIcon className={styles.icon} />
        </button>
      </div>
    )
  }
}

export default VideoControlsFullscreen
